import { render, staticRenderFns } from "./PaymentsModal.vue?vue&type=template&id=56852b63&scoped=true&"
import script from "./PaymentsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56852b63",
  null
  
)

export default component.exports